module.exports = __webpack_public_path__ + "media/images/icons/store_categories/icon-store-category-0-ce838634fab87e3c57374b88b07b7f04.svg";